import { gql } from "@apollo/client";

// Company-wide buyer wants & needs, optionally narrowed to one agent's buyers.
// The server never returns a buyer's name or contact details here — only the
// buyer id, whose last four characters identify the record on a shared screen.
export const GET_COMPANY_BUYER_NEEDS = gql`
  query getCompanyBuyerNeeds(
    $companyId: String!
    $agentId: String
    $criteriaInput: FilteringCriteriaInput
    $search: String
    $sortBy: String
    $pagination: pagination
  ) {
    getCompanyBuyerNeeds(
      companyId: $companyId
      agentId: $agentId
      criteriaInput: $criteriaInput
      search: $search
      sortBy: $sortBy
      pagination: $pagination
    ) {
      totalCount
      criteria {
        _id
        buyerId
        title
        cities
        zipCodes
        minPrice
        maxPrice
        minBeds
        maxBeds
        minBath
        maxBath
        minSqFt
        maxSqFt
        propertyType
        notes
        createdAt
        agentName
        amenities {
          _id
          title
        }
      }
    }
  }
`;

// The buyers in this office whose wants & needs match one listing — the broker's
// view. Separate from the agent-scoped getListingBuyerMatches, and returns no
// buyer identity: the id's last four characters are how the room refers to them.
export const GET_LISTING_BUYER_MATCHES_FOR_COMPANY = gql`
  query getCompanyListingBuyerMatches($listingId: String!) {
    getCompanyListingBuyerMatches(listingId: $listingId) {
      _id
      buyerId
      cities
      zipCodes
      minPrice
      maxPrice
      minBeds
      maxBeds
      minBath
      maxBath
      minSqFt
      maxSqFt
      propertyType
      agentName
    }
  }
`;
